import { analytics } from '@/features/analytics/events'
import { isCaptchaFailedError, useTurnstileCaptcha } from '@/features/turnstile'
import { t } from '@lingui/core/macro'
import { toast } from 'sonner'
import { useSubmitNectarTask } from '../api'

type Captcha = ReturnType<typeof useTurnstileCaptcha>

export type CaptchaOptions = {
  captcha: Pick<Captcha, 'token' | 'reset'>
}

type SubmitArgs = {
  projectId: string
  taskId: string
  taskIndex: number
  answers: Record<string, unknown>
  onSuccess?: () => void
  onError?: () => void
}

export const useSubmitAudioAnnotation = ({ captcha }: CaptchaOptions) => {
  const { mutateAsync: submitTask, isPending } = useSubmitNectarTask()

  const submit = async ({ projectId, taskId, taskIndex, answers, onSuccess, onError }: SubmitArgs) => {
    try {
      await submitTask({
        projectId,
        taskId,
        data: { answers },
        turnstileToken: captcha.token ?? undefined
      })
      captcha.reset()
      toast.success(t`Submitted!`)
      analytics.missionTaskSubmitted(projectId, taskId, taskIndex)
      onSuccess?.()
    } catch (err) {
      captcha.reset()
      if (isCaptchaFailedError(err)) {
        toast.error(t`Verification failed. Please try again.`)
      } else {
        toast.error(t`Failed to submit`)
      }
      onError?.()
    }
  }

  return { submit, isSubmitting: isPending }
}
